import { type LucideProps } from 'lucide-react'
import { LatitudeLogoMonochrome } from '..'

export default function Ghost(props: LucideProps) {
  // TODO: Cannot find svg logo for Ghost
  return <LatitudeLogoMonochrome {...props} />
}
